// extracted by mini-css-extract-plugin
export var footerHolder = "Footer-module--footerHolder--4768c";